/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_MigrationsInputs */

const en_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrations`)
};

const ar_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترحيل`)
};

const bn_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাইগ্রেশন`)
};

const de_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrationen`)
};

const es_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migraciones`)
};

const fr_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrations`)
};

const pt_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrações`)
};

const zh_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迁移`)
};

const tr_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taşımalar`)
};

const ru_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Миграции`)
};

const pl_svchip_migrations = /** @type {(inputs: Svchip_MigrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migracje`)
};

/**
* | output |
* | --- |
* | "Migrations" |
*
* @param {Svchip_MigrationsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_migrations = /** @type {((inputs?: Svchip_MigrationsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_MigrationsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_migrations(inputs)
	if (locale === "bn") return bn_svchip_migrations(inputs)
	if (locale === "de") return de_svchip_migrations(inputs)
	if (locale === "es") return es_svchip_migrations(inputs)
	if (locale === "fr") return fr_svchip_migrations(inputs)
	if (locale === "pt") return pt_svchip_migrations(inputs)
	if (locale === "zh") return zh_svchip_migrations(inputs)
	if (locale === "tr") return tr_svchip_migrations(inputs)
	if (locale === "ru") return ru_svchip_migrations(inputs)
	if (locale === "pl") return pl_svchip_migrations(inputs)
	return en_svchip_migrations(inputs)
});